import './factore.scss';
import { withRouter } from '~HOC';
import momentjs from 'moment-jalaali';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { numberWithCommas } from '../../../utils/consts';
import { injectIntl, FormattedMessage } from 'react-intl';
import { fileHandlerUrl } from '../../../utils/consts/server';
import Signature from '../../../content/images/common/signature.png';
import TripordLogo from '../../../content/images/icon/tripord-logo.webp';
import TripsiLogo from '../../../content/images/icon/tripsi-logo.webp';
import { Button, FormatLastNumberColor, Tooltip } from '../../../component';

const RenderItem = ({ title, value, valueClassName, direction }) => {
  const isAddress = title.includes('address');
  return (
    <div className="text-third d-flex justify-content-xl-start justify-content-start pb-4 text-nowrap">
      <FormattedMessage id={title} />
      <span className="px-2">:</span>
      <Tooltip
        position={'bottom'}
        content={value || ''}
        direction={direction}
        backgroundColor="warning"
        textColor="dark"
        customClassName="col-xl-10 col-8 px-0 text-start"
      >
        <div className="col-xxl-9 col-sm-8 w-100 d-flex px-0">
          <span
            className={`text-secondary-dark ${
              isAddress ? 'text-wrap' : 'text-nowrap text-truncate'
            } ${valueClassName}`}
          >
            {value || '--'}
          </span>
        </div>
      </Tooltip>
    </div>
  );
};

function SalesInvoice(props) {
  const [factoreData, setFactoreData] = useState([]);
  const [isBusiness, setIsBusiness] = useState(false);
  const {
    intl,
    handleCancel,
    data,
    language,
    language: { direction, name },
  } = props;
  const isTripord = window?.location?.origin?.includes?.('tripord') 
  const serviceDescription = `${data?.flights?.itineraries[0]?.flights?.[0]?.departureAirport?.cityName?.[name]}-${data?.flights?.itineraries[0]?.flights?.[0]?.arrivalAirport?.cityName?.[name]}`;
  return (
    <React.Fragment key={`sales-invoice`}>
      <div className="w-100 h-100 d-flex flex-column">
        <div className="w-100 d-flex flex-sm-row flex-column-reverse justify-content-between pb-4 mb-2">
          <div className="d-flex flex-row">
            <img
              className={`p-0 font-small cursor-pointer`}
              src={isTripord ? TripordLogo : TripsiLogo}
              width={130}
              height={isTripord ? '40px' : '55px'}
              alt={isTripord ? 'tripord icon' : 'tripsi icon'}
            />
            <div className="d-flex flex-column justify-content-center px-3">
              <span className="fw-bold text-start">
                <FormattedMessage id={'booking.tripsi'} />
              </span>
              <span className="text-third text-start pt-1">
                <FormattedMessage id={'profile.Invoice'} />
              </span>
            </div>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-sm-start align-items-end pb-sm-0 pb-3">
            <div className="d-flex flex-row">
              <span className="text-third px-1 text-nowrap">
                <FormattedMessage id={'profile.factoreno'} /> :
              </span>
              <span>{data?.invoiceNo ?? '--'}</span>
            </div>
            <div className="d-flex flex-row pt-1">
              <span className="text-third px-1 text-nowrap">
                <FormattedMessage id={'createBill.date'} /> :
              </span>
              <span>
                {momentjs(
                  new Date(data?.orderDate).toLocaleDateString(),
                  'M/D/YYYY',
                ).format('YYYY-MM-DD') || '---'}
              </span>
            </div>
          </div>
        </div>
        <div className="d-flex flex-row flex-wrap">
          <div className="col-xl-4 col-12">
            <RenderItem
              title={'profile.sellername'}
              value={<FormattedMessage id="booking.tripsi" />}
              direction={direction}
            />
            <RenderItem
              title={'profile.businessnationalid'}
              value={''}
              direction={direction}
            />
          </div>
          <div className="col-xl-4 col-12">
            <RenderItem
              title="profile.businesseconomiccode"
              value={''}
              direction={direction}
            />
            <RenderItem
              title="booking.phone"
              value={''}
              direction={direction}
            />
          </div>
          <div className="col-xl-4 col-12">
            <RenderItem
              title="profile.registercode"
              value={''}
              direction={direction}
            />
            <RenderItem
              title="profile.postalcode"
              value={''}
              direction={direction}
            />
          </div>
        </div>
        <div className="col-12 d-flex flex-column align-items-center">
          <div className="w-100">
            <RenderItem
              title="profile.address"
              value={
                <FormattedMessage
                  id={`${
                    isTripord ? 'aboutus.canadaaddress' : 'aboutus.address'
                  }`}
                  valueClassName={'text-wrap text-start'}
                  direction={direction}
                />
              }
            />
          </div>
          <span className="col-10 border-bottom border-2 border-third-light"></span>
        </div>
        <div className="d-flex flex-row flex-wrap pt-4">
          <div className="col-xl-4 col-12">
            {data?.issuerContactInfo ? (
              <RenderItem
                title="profile.customername"
                value={
                  data?.issuerContactInfo?.firstName +
                  ' ' +
                  data?.issuerContactInfo?.lastName
                }
                direction={direction}
              />
            ) : (
              <RenderItem
                title="profile.customername"
                value={data?.onBehalfProfile?.displayName[language?.name]}
                direction={direction}
              />
            )}
            {data?.issuerContactInfo ? (
              ''
            ) : (
              <RenderItem
                title="profile.businesseconomiccode"
                value={data?.onBehalfProfile?.basicInfo?.nationalCode}
                direction={direction}
              />
            )}
          </div>
          <div className="col-xl-4 col-12">
            {data?.issuerContactInfo ? (
              <RenderItem
                title={'profile.nationalcode'}
                value={data?.basicInfo?.nationalCode}
                direction={direction}
              />
            ) : (
              <RenderItem
                title="profile.registercode"
                value={data?.onBehalfProfile?.basicInfo?.economicCode}
                direction={direction}
              />
            )}
            {data?.issuerContactInfo ? (
              ''
            ) : (
              <RenderItem
                title={'profile.businessmanagername'}
                value={data?.onBehalfProfile?.basicInfo?.managerName}
                direction={direction}
              />
            )}
          </div>
          <div className="col-xxl-4 col-12">
            {data?.issuerContactInfo ? (
              <RenderItem
                title="profile.phonenumber"
                value={data?.issuerContactInfo?.mobile}
                valueClassName={'phoneNumber'}
                direction={direction}
              />
            ) : (
              <RenderItem
                title="profile.phonenumber"
                value={data?.onBehalfProfile?.basicInfo?.phone?.[0]}
                valueClassName={'phoneNumber'}
                direction={direction}
              />
            )}
          </div>
        </div>
        <div className="col-12">
          {data?.issuerContactInfo && (
            <RenderItem
              title="booking.email"
              value={data?.issuerContactInfo?.email}
              valueClassName={'text-truncate'}
              direction={direction}
            />
          )}
        </div>
        <div className="col-12">
          {data?.issuerContactInfo ? (
            <RenderItem
              title="profile.address"
              value={data?.issuerContactInfo?.address}
              direction={direction}
            />
          ) : (
            <RenderItem
              title="profile.address"
              value={data?.onBehalfProfile?.addresses?.[0]?.Address}
              direction={direction}
            />
          )}
        </div>
        <div className="w-100 pb-4 table-responsive">
          <table className="table table-bordered text-start font-small table-striped table-bordered">
            <thead className="text-nowrap">
              <tr>
                <th className="text-third" scope="col">
                  {intl.formatMessage({ id: 'profile.row' })}
                </th>
                <th className="text-third" scope="col">
                  {intl.formatMessage({ id: 'booking.passengername' })}
                </th>
                <th className="text-third" scope="col">
                  {intl.formatMessage({ id: 'booking.ticketno' })}
                </th>
                <th className="text-third" scope="col">
                  {intl.formatMessage({ id: 'profile.servicedescription' })}
                </th>
                <th className="text-third" scope="col">
                  {intl.formatMessage({ id: 'profile.airlinename' })}
                </th>
                <th className="text-third" scope="col">
                  {intl.formatMessage({ id: 'profile.purchaseamount' })}
                </th>
                <th className="text-third" scope="col">
                  {intl.formatMessage({ id: 'profile.taxesduties' })}
                </th>
                <th className="text-third" scope="col">
                  {intl.formatMessage({ id: 'booking.totalamount' })}
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.passengers?.map((item, index) => {
                return (
                  <React.Fragment key={`factore-${index}`}>
                    <tr className="font-msmall" key={`table-invoice-${index}`}>
                      <td className="text-dark" scope="row">
                        {index + 1}
                      </td>
                      <td className="text-dark" scope="row">
                        {item?.firstName + ' ' + item?.lastName}
                      </td>
                      <td className="text-dark" scope="row">
                        {data?.tickets?.[index]?.ticketNumber}
                      </td>
                      <td className="text-dark" scope="row">
                        {serviceDescription}
                      </td>
                      <td className="text-dark" scope="row">
                        {data?.gateways?.map((item) => {
                          return item?.name;
                        })}
                      </td>
                      <td className="text-dark" scope="row">
                        {numberWithCommas(item?.price?.baseFare) || '---'}
                      </td>
                      <td className="text-dark" scope="row">
                        {numberWithCommas(item?.price?.tax) || '---'}
                      </td>
                      <td className="text-dark" scope="row">
                        {numberWithCommas(item?.price?.totalPrice) || '---'}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          <div className="price-table d-flex flex-row justify-content-start px-2">
            <div className="d-flex font-xsmall py-1 font-weight-bold text-white align-items-center px-2 p-0 m-0">
              <div
                className={`d-flex font-xsmall  font-weight-bold mobile-light-color justify-content-end align-items-center px-1 p-0 m-0`}
              >
                <FormattedMessage
                  id="booking.allpassengerprice"
                  defaultMessage="booking.allpassengerprice"
                />
                {' : '}
              </div>
              <div
                className={`d-flex font-msmall text-primary font-weight-bold mobile-light-color px-1 py-0 justify-content-end align-items-center border-third`}
                style={{
                  borderLeft: language?.name === 'en' ? '1px dotted' : '0',
                  borderRight: language?.name === 'fa' ? '1px dotted' : '0',
                }}
              >
                {numberWithCommas(data?.totalPrice)}
                <span className="px-1">
                  <FormattedMessage id="language.rial" />
                </span>
              </div>
            </div>
          </div>
          <div className="price-table d-flex flex-row justify-content-start px-2">
            <div className="d-flex font-xsmall py-1 font-weight-bold text-white align-items-center px-2 p-0 m-0">
              <div
                className={`d-flex font-xsmall  font-weight-bold mobile-light-color justify-content-end align-items-center px-1 p-0 m-0`}
              >
                <FormattedMessage id={'booking.paymentprice'} />
                {' : '}
              </div>
              <div
                className={`d-flex font-msmall text-primary font-weight-bold mobile-light-color px-1 py-0 justify-content-end align-items-center border-third`}
                style={{
                  borderLeft: language?.name === 'en' ? '1px dotted' : '0',
                  borderRight: language?.name === 'fa' ? '1px dotted' : '0',
                }}
              >
                {numberWithCommas(data?.totalPriceToPayment)}
                <span className="px-1">
                  <FormattedMessage id="language.rial" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-lg-row flex-column-reverse justify-content-lg-between align-items-lg-start align-items-lg-end">
          <div className="d-flex flex-sm-row flex-column-reverse align-items-end col-lg-8 col-12 px-0 pt-lg-0 pt-4">
            <div className="col-xxl-2 col-lg-3 col-sm-6 col-12 px-0">
              <Button
                name={`cancel-salesInvoice`}
                id={`cancel-salesInvoice`}
                label={intl.formatMessage({
                  id: `profile.cancel`,
                })}
                className={`bg-white border rounded-2 text-danger text-nowrap py-sm-0 py-3 col-lg-12 col-sm-11 col-12`}
                onClick={handleCancel}
              />
            </div>
            <div className="d-flex flex-row justify-content-sm-end jusstify-content-start col-xxl-2 col-lg-3 col-sm-6 col-12 mx-lg-3 mx-0 mb-sm-0 mb-3 px-0">
              <Button
                name={`print-salesInvoice`}
                id={`print-salesInvoice`}
                label={intl.formatMessage({
                  id: 'profile.printinvoice',
                })}
                className={`btn-white border rounded-2 text-danger text-nowrap px-3 py-sm-0 py-3 col-lg-12 col-sm-11 col-12 px-0`}
                onClick={() => {
                  // do cancel
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-row justify-content-lg-end justify-content-start col-lg-4 col-12 px-0">
            <img
              src={Signature}
              alt="signature"
              className="p-3 border rounded mx-2 signature"
            />
            <div className="d-flex flex-column justify-content-center">
              <span className="text-start text-gray font-msmall text-nowrap fw-bold">
                <FormattedMessage id="profile.signature" />
              </span>
              <span className="text-start text-third font-smaller pt-2">
                <FormattedMessage id="profile.signaturetext" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}

export default injectIntl(connect(mapStateToProps)(withRouter(SalesInvoice)));